import * as React from "react";
function SvgTarget(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M41.2 7.3C32-2.2 16.9-2.4 7.3 6.8s-9.7 24.3-.5 33.9 24.3 9.7 33.9.5c4-3.9 6.6-9.2 7.2-14.7.7-7.1-1.8-14.1-6.7-19.2zm4.1 18.9c-1.1 11.7-11.7 20.4-23.4 19.2C10.2 44.2 1.5 33.7 2.8 21.9S14.4 1.6 26.2 2.7c5 .5 9.7 2.8 13.2 6.4 4.4 4.5 6.6 10.8 5.9 17.1zm-21.2-11c4.9 0 8.8 3.9 8.8 8.8s-3.9 8.8-8.8 8.8-8.9-3.8-8.9-8.8 3.9-8.8 8.9-8.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTarget);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
